import { getRequiredEnvValue } from '../env';
import { RawWord, FormattedDefaultTranscript } from '../types/transcript-types';

export const getRecordingSubtitleUrl = (event: string, broadcast: string) => (suffix: string) =>
  `${getRequiredEnvValue('VUE_APP_VID_CDN_URL')}${event}/${broadcast}/recording/subtitles/${suffix}`;
export function getTranscriptDataInRequiredFormat(words: RawWord[]): FormattedDefaultTranscript {
  return words.map(({ alternatives, start_time, end_time, ...word }: RawWord, index: number) => {
    const startTime = words[index + 1]?.start_time;
    const endTime = words[index - 1]?.end_time;

    return {
      ...word,
      start_time: start_time ? +start_time : endTime ? +endTime : endTime,
      end_time: end_time ? +end_time : startTime ? +startTime : startTime,
      content: alternatives[0].content ?? '',
      index
    };
  });
}
export function getFilteredWords(words: RawWord[], clip_start_time?: number, clip_end_time?: number) {
  return clip_start_time === undefined || clip_end_time === undefined
    ? words
    : words.filter(({ start_time, end_time }, index) => {
        const actual_start_time = start_time ? start_time : words[index - 1]?.start_time;
        const actual_end_time = end_time ? end_time : words[index + 1]?.end_time;

        return (
          clip_start_time === undefined ||
          clip_end_time === undefined ||
          (+actual_start_time >= clip_start_time && +actual_end_time <= clip_end_time)
        );
      });
}
